export type BusinessWorkspaceTab = 'home' | 'events' | 'organization' | 'team';

export function formatWorkspaceRole(role: string) {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export function canManageTeamTarget(actorRole?: string, targetRole?: string) {
  if (actorRole === 'owner') {
    return targetRole === 'manager' || targetRole === 'social' || targetRole === 'staff';
  }
  if (actorRole === 'manager') {
    return targetRole === 'social' || targetRole === 'staff';
  }
  return false;
}

export function formatWorkspaceMetric(value: number) {
  return new Intl.NumberFormat().format(value);
}

export function formatWorkspaceEventTime(value: string) {
  return new Date(value).toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function getBusinessWorkspaceHref(organizationID: string, tab: BusinessWorkspaceTab) {
  if (tab === 'home') {
    return `/workspaces/${organizationID}` as const;
  }
  return `/workspaces/${organizationID}/${tab}` as const;
}

export function getBusinessShellHref(tab: BusinessWorkspaceTab) {
  if (tab === 'home') {
    return '/(business)/home' as const;
  }
  return `/(business)/${tab}` as const;
}
